import parse from "html-react-parser";

/**
 * Renderiza um texto vindo do JSON de configuração das tarefas permitindo
 * formatação inline — <b>/<strong>, <i>/<em>, <u>, <br>, <span>, etc.
 *
 * Mesmo tratamento já aplicado a question.description, instruments.instructions
 * e consent_terms.description (ver Questions.tsx, Instructions.tsx, Consent.tsx):
 * o conteúdo é HTML autorado pelo admin e passa por html-react-parser.
 *
 * parse() estoura em null/undefined, daí o `?? ""` — mesmo motivo do guard usado
 * nas telas (ver nullSafety.fix.test.tsx).
 */
export const richText = (value?: string | null) => parse(value ?? "");

export default richText;
